import { Injectable } from '@angular/core';
import { Response } from '@angular/http';

import { environment } from '../../../../environments/environment';
import { UserBuilder } from '../../models/builders/user.builder';
import { User } from '../../models/user';
import { HttpService } from '../base/http.service';

const userRequest = (user: User) => {
  return {
    firstname: user.firstname,
    lastname: user.lastname,
    birthDate: user.birthDate,
    email: user.email
  };
};

@Injectable()
export class UserHttpService {
  private apiUrl: string;

  constructor(private httpService: HttpService) {
    this.apiUrl = environment.apiUrl;
  }

  getAccount() {
    return this.httpService.get(`${this.apiUrl}users/me`)
      .map((response: Response) => response.json())
      .map(UserBuilder.fromJson);
  }

  save(user: User) {
    const putBody = userRequest(user);
    return this.httpService.put(`${this.apiUrl}users/me`, putBody);
  }

  savePassword(password: string, passwordRepeat: string) {
    const putBody = { password, passwordRepeat };
    return this.httpService.put(`${this.apiUrl}password`, putBody);
  }

  savePin(pin: string, pinRepeat: string) {
    const putBody = { pin, pinRepeat };
    return this.httpService.put(`${this.apiUrl}pin`, putBody);
  }
}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/core/services/api/user-http.service.ts